import { toast } from 'sonner';

// Surfaces the non-blocking double-booking warning returned by PUT /jobs/{id}
// after a date change shifted the job's allocations (`_allocation_conflicts`).
export function notifyAllocationConflicts(data) {
  const conflicts = data && data._allocation_conflicts;
  if (!Array.isArray(conflicts) || conflicts.length === 0) return;

  const fmt = (c) => {
    const jobRef = c.conflicting_job_number
      ? `Job #${c.conflicting_job_number}`
      : (c.conflicting_job_description || 'another job');
    const kind = c.resource_type === 'asset' ? 'Asset' : 'Operator';
    const start = c.dates?.start || '';
    const end = c.dates?.end;
    const range = end && end !== start ? `${start}–${end}` : start;
    return `${kind} ${c.resource_label} is also booked on ${jobRef} (${range})`;
  };

  const lines = conflicts.slice(0, 4).map(fmt);
  if (conflicts.length > 4) lines.push(`+${conflicts.length - 4} more`);

  toast.warning('Double-booking after date change', {
    description: lines.join('\n'),
    duration: 12000,
  });
}
